import {
  initRawSchema,
  RawSchema,
  toMentionContent,
  toParagraphContent,
  toTextContent,
} from '@principle-theorem/editor';
import {
  INotification,
  INotificationContextRenderer,
} from '@principle-theorem/notifications';
import {
  NotificationType,
  IBookedAppointmentResources,
  isAppointmentResource,
  MentionResourceType,
  IEvent,
} from '@principle-theorem/principle-core/interfaces';
import {
  CALENDAR_TIME_FORMAT,
  IReffable,
  toMoment,
} from '@principle-theorem/shared';
import { Event } from '../../event/event';
import { toMention } from '../../mention/mention';

export class PatientBookedAppointmentContextRenderer
  implements
    INotificationContextRenderer<
      RawSchema,
      NotificationType,
      IBookedAppointmentResources
    >
{
  canRender(notification: INotification): boolean {
    return (
      notification.type === String(NotificationType.PatientBookedAppointment)
    );
  }

  isResource(data: unknown): data is IBookedAppointmentResources {
    return isAppointmentResource<IBookedAppointmentResources>(data);
  }

  render(
    data: IBookedAppointmentResources,
    _currentStaffer?: IReffable
  ): RawSchema {
    const event: IEvent = Event.init(data.appointment.event);
    const startTime: string = toMoment(event.from).calendar(
      undefined,
      CALENDAR_TIME_FORMAT
    );

    const patientMention = toMention(data.patient, MentionResourceType.Patient);
    const appointmentMention = toMention(
      { name: startTime, ref: data.appointment.ref },
      MentionResourceType.Appointment
    );

    return initRawSchema([
      toParagraphContent([
        toMentionContent(patientMention),
        toTextContent(' booked in for '),
        toMentionContent(appointmentMention),
      ]),
    ]);
  }
}
